// src/pages/public/Blogs.tsx

import React, { useState, useEffect } from 'react';
// ✅ FIX: Use a default import for the service object
import blogService from '../../services/blogService';
import type { IBlog } from '../../types/blog';
import Loader from '../../components/common/Loader';
import { showToast } from '../../utils/showToast';
import BlogCard from '../../components/blog/BlogCard';

const Blogs: React.FC = () => {
  const [blogs, setBlogs] = useState<IBlog[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      setIsLoading(true);
      try {
        // ✅ FIX: Call the correct function from the service object
        const data = await blogService.getAllPublishedBlogs();
        setBlogs(data);
      } catch (err: any) {
        setError(err.message);
        showToast(err.message, { type: 'error' });
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (isLoading) {
    return <div className="flex justify-center items-center h-screen"><Loader /></div>;
  }

  if (error) {
    return <div className="text-center py-10"><p className="text-red-600">Error: {error}</p></div>;
  }

  return (
    <div className="py-10 px-4">
      <div className="max-w-7xl mx-auto text-center mb-10">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Our Blog</h1>
        <p className="text-lg text-gray-600">
          Stay updated with the latest in the industry, trends, and more.
        </p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogs.length === 0 ? (
          <p className="col-span-full text-center text-gray-500">No blog posts published yet.</p>
        ) : (
          blogs.map((blog) => (
            <BlogCard key={blog._id} blog={blog} />
          ))
        )}
      </div>
    </div>
  );
};

export default Blogs;